<style lang="scss">
.connect-distribution-title {
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #ff9900;
    color: #fff;
}
</style>
<template>
    <div class="distribution">
        <div class="bg-fff margin-top-20 padding-bottom-20">
            <header class="connect-distribution-title font-bold">
                {{
                    $t("erp.distribution.connect_distribution", {
                        defaultValue: "关联配货单",
                    })
                }}
                <span
                    @click="toDistributionList"
                    style="padding: 5px; font-size: 14px; cursor: pointer"
                >
                    <Icon type="ios-browsers-outline" />
                </span>
            </header>
            <Table
                class="margin-10"
                :columns="columns"
                :data="formList"
                size="small"
                ref="table"
                border
                stripe
            ></Table>
        </div>
        <Modal v-model="modalProps.show" :footer-hide="true" :closable="escCloseModal" v-bind="modalProps" @on-closeCloseable="escCloseModal = false" @on-openCloseable="escCloseModal = true">
            <component :is="modalProps.component" v-bind="modalProps.props" @on-close="$emit('on-openCloseable')"></component>
        </Modal>
    </div>
</template>
<script>
import mixin from "@/views/boss/distribution/mixin.js";
import compDisturibution from "@/views/boss/distribution/update/index.vue";
export default {
    props: ["baseInfo", "distributionData"],
    components: {
        compDisturibution
    },
    mixins: [mixin],
    data() {
        return {
            orderNo: `${this.baseInfo.orderId} / ${this.baseInfo.orderNo}`,
            formList: [],
            modalProps: {
                show: false
            },
            escCloseModal: true
        };
    },
    watch: {
        distributionData: {
            immediate: true,
            handler(val) {
                this.distributionData = val;
                this.handleData();
            }
        }
    },
    created() {
        this.handleData();
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t('erp.b2c.search_ordernumber', { defaultValue: "订单号" }),
                    render: (h, { row }) => {
                        return <div>{this.orderNo}</div>;
                    },
                },
                {
                    title: this.$t('erp.distribution.deliverorderno', { defaultValue: "配货单号" }),
                    key: "deliverOrderNo",
                    render: (h, { row }) => {
                        return (
                            <div>
                                <a
                                    onClick={this.toDistribution.bind(
                                        this,
                                        row.deliverOrderId
                                    )}
                                >
                                    {row.deliverOrderNo}
                                </a>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t('erp.distribution.order_status', { defaultValue: "配货单状态" }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <span class="status-color">
                                    {row.statusLabel}
                                </span>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t('erp.b2c.search_errorcode', { defaultValue: "异常类型" }),
                    render: (h, { row }) => {
                        if (row.errorLabel == "--")
                            return <div>{row.errorLabel}</div>;
                        else
                            return (
                                <div class="error-status">{row.errorLabel}</div>
                            );
                    },
                },
            ];
        },
    },
    methods: {
        handleData () {
            this.formList = this.distributionData.map((item) => {
                return {
                    ...item,
                    errorLabel: this.getError(item.deliverOrderErrorCode),
                    statusLabel: this.getStatus(item.deliverOrderStatus),
                };
            });
        },
        getStatus(type) {
            let itemLabel = this.distributionStatus.filter((item) => {
                return item.value === type;
            })[0];
            if (!itemLabel) return;
            return itemLabel.label;
        },
        getError(errCode) {
            console.log(errCode);
            if (errCode == 0) return "--";
            let item = this.distributionException.filter((item) => {
                return item.value == errCode;
            })[0];
            if (!item) return;
            return item.label;
        },
        toDistribution(id) {
            this.$emit('on-closeCloseable');
            this.modalProps = {
                show: true,
                component: compDisturibution,
                width: 1200,
                title: this.$t('fbb.alloment.detail', { defaultValue: '详情' }),
                showFooter: false,
                props: {
                    activeid: id,
                    querytype: 'query'
                }
            }
            // let url = this.$router.resolve({
            //     path: `distribution/update/query?id=${id}`,
            // });
            // window.open(url.href, "_blank");
        },
        toDistributionList() {
            console.log(this.distributionData);
            let url = this.$router.resolve({
                path: `distribution?sourceNo=${this.distributionData[0].sourceNo}`,
            });
            window.open(url.href, "_blank");
        },
    },
};
</script>
<style lang="scss">
.distribution {
    .status-color {
        display: inline-block;
        padding: 3px 8px;
        border: 1px solid #808695;
        border-radius: 8px;
        color: #808695;
    }

    .error-status {
        display: inline-block;
        padding: 2px 5px;
        background-color: #ed4014;
        color: #fff;
        // border-radius: 8px;
    }
}
</style>